 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML04_LIST_OF_MAPS from '@/components/xhtml/04_List_of_Maps'
 import XHTML05_PREFACE from '@/components/xhtml/05_Preface'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_Introduction'
 import XHTML07_NOTE_ON_SOURCES from '@/components/xhtml/07_Note_on_Sources'
 import XHTML08_ENVIRONMENT from '@/components/xhtml/08_Environment'
 import XHTML09_KHITAN_WAR_MACHINE from '@/components/xhtml/09_Khitan_War_Machine'
 import XHTML10_PART1 from '@/components/xhtml/10_Part1'
 import XHTML11_CHAPTER_01 from '@/components/xhtml/11_Chapter_01'
 import XHTML12_CHAPTER_02 from '@/components/xhtml/12_Chapter_02'
 import XHTML13_CHAPTER_03 from '@/components/xhtml/13_Chapter_03'
 import XHTML14_CHAPTER_03A from '@/components/xhtml/14_Chapter_03a'
 import XHTML15_CHAPTER_04 from '@/components/xhtml/15_Chapter_04'
 import XHTML16_CHAPTER_05 from '@/components/xhtml/16_Chapter_05'
 import XHTML17_CHAPTER_06 from '@/components/xhtml/17_Chapter_06'
 import XHTML18_CHAPTER_07 from '@/components/xhtml/18_Chapter_07'
 import XHTML19_CHAPTER_08 from '@/components/xhtml/19_Chapter_08'
 import XHTML20_CHAPTER_09 from '@/components/xhtml/20_Chapter_09'
 import XHTML21_CHAPTER_10 from '@/components/xhtml/21_Chapter_10'
 import XHTML22_CHAPTER_11 from '@/components/xhtml/22_Chapter_11'
 import XHTML23_CHAPTER_12 from '@/components/xhtml/23_Chapter_12'
 import XHTML24_CHAPTER_12A from '@/components/xhtml/24_Chapter_12a'
 import XHTML25_CHAPTER_13 from '@/components/xhtml/25_Chapter_13'
 import XHTML26_CHAPTER_14 from '@/components/xhtml/26_Chapter_14'
 import XHTML27_CHAPTER_15 from '@/components/xhtml/27_Chapter_15'
 import XHTML28_CHAPTER_16 from '@/components/xhtml/28_Chapter_16'
 import XHTML29_CHAPTER_17 from '@/components/xhtml/29_Chapter_17'
 import XHTML30_CHAPTER_17A from '@/components/xhtml/30_Chapter_17a'
 import XHTML31_CHAPTER_18 from '@/components/xhtml/31_Chapter_18'
 import XHTML32_CHAPTER_19 from '@/components/xhtml/32_Chapter_19'
 import XHTML33_CHAPTER_20 from '@/components/xhtml/33_Chapter_20'
 import XHTML34_CHAPTER_21 from '@/components/xhtml/34_Chapter_21'
 import XHTML35_CHAPTER_22 from '@/components/xhtml/35_Chapter_22'
 import XHTML36_CHAPTER_23 from '@/components/xhtml/36_Chapter_23'
 import XHTML37_CHAPTER_24 from '@/components/xhtml/37_Chapter_24'
 import XHTML38_CHAPTER_24A from '@/components/xhtml/38_Chapter_24a'
 import XHTML39_CHAPTER_25 from '@/components/xhtml/39_Chapter_25'
 import XHTML40_CHAPTER_26 from '@/components/xhtml/40_Chapter_26'
 import XHTML41_CHAPTER_27 from '@/components/xhtml/41_Chapter_27'
 import XHTML42_PARTII from '@/components/xhtml/42_PartII'
 import XHTML43_CHAPTER_28 from '@/components/xhtml/43_Chapter_28'
 import XHTML44_CHAPTER_29 from '@/components/xhtml/44_Chapter_29'
 import XHTML45_CHAPTER_29A from '@/components/xhtml/45_Chapter_29a'
 import XHTML46_CHAPTER_30 from '@/components/xhtml/46_Chapter_30'
 import XHTML47_CHAPTER_31 from '@/components/xhtml/47_Chapter_31'
 import XHTML48_CHAPTER_32 from '@/components/xhtml/48_Chapter_32'
 import XHTML49_CHAPTER_33 from '@/components/xhtml/49_Chapter_33'
 import XHTML50_CHAPTER_34 from '@/components/xhtml/50_Chapter_34'
 import XHTML51_CHAPTER_35 from '@/components/xhtml/51_Chapter_35'
 import XHTML52_CHAPTER_36 from '@/components/xhtml/52_Chapter_36'
 import XHTML53_CHAPTER_36A from '@/components/xhtml/53_Chapter_36a'
 import XHTML54_CHAPTER_37 from '@/components/xhtml/54_Chapter_37'
 import XHTML55_CHAPTER_38 from '@/components/xhtml/55_Chapter_38'
 import XHTML56_CHAPTER_39 from '@/components/xhtml/56_Chapter_39'
 import XHTML57_CHAPTER_40 from '@/components/xhtml/57_Chapter_40'
 import XHTML58_CHAPTER_41 from '@/components/xhtml/58_Chapter_41'
 import XHTML59_CHAPTER_42 from '@/components/xhtml/59_Chapter_42'
 import XHTML60_CHAPTER_43 from '@/components/xhtml/60_Chapter_43'
 import XHTML61_CHAPTER_44 from '@/components/xhtml/61_Chapter_44'
 import XHTML62_CHAPTER_45 from '@/components/xhtml/62_Chapter_45'
 import XHTML63_CHAPTER_45A from '@/components/xhtml/63_Chapter_45a'
 import XHTML64_CHAPTER_46 from '@/components/xhtml/64_Chapter_46'
 import XHTML65_CHAPTER_47 from '@/components/xhtml/65_Chapter_47'
 import XHTML66_CHAPTER_48 from '@/components/xhtml/66_Chapter_48'
 import XHTML67_CHAPTER_49 from '@/components/xhtml/67_Chapter_49'
 import XHTML68_CHAPTER_50 from '@/components/xhtml/68_Chapter_50'
 import XHTML69_CHAPTER_51 from '@/components/xhtml/69_Chapter_51'
 import XHTML70_CHAPTER_52 from '@/components/xhtml/70_Chapter_52'
 import XHTML71_CHAPTER_53 from '@/components/xhtml/71_Chapter_53'
 import XHTML72_CHAPTER_54 from '@/components/xhtml/72_Chapter_54'
 import XHTML73_APPENDIXI from '@/components/xhtml/73_AppendixI'
 import XHTML74_APPENDIXII from '@/components/xhtml/74_AppendixII'
 import XHTML75_BIBLIOGRAPHY from '@/components/xhtml/75_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Title",
 			"name" : "xhtml/01_Title",
 			"component" : XHTML01_TITLE
 		},
 		{
 			"path" : "/xhtml/02_Copyright",
 			"name" : "xhtml/02_Copyright",
 			"component" : XHTML02_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/04_List_of_Maps",
 			"name" : "xhtml/04_List_of_Maps",
 			"component" : XHTML04_LIST_OF_MAPS
 		},
 		{
 			"path" : "/xhtml/05_Preface",
 			"name" : "xhtml/05_Preface",
 			"component" : XHTML05_PREFACE
 		},
 		{
 			"path" : "/xhtml/06_Introduction",
 			"name" : "xhtml/06_Introduction",
 			"component" : XHTML06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07_Note_on_Sources",
 			"name" : "xhtml/07_Note_on_Sources",
 			"component" : XHTML07_NOTE_ON_SOURCES
 		},
 		{
 			"path" : "/xhtml/08_Environment",
 			"name" : "xhtml/08_Environment",
 			"component" : XHTML08_ENVIRONMENT
 		},
 		{
 			"path" : "/xhtml/09_Khitan_War_Machine",
 			"name" : "xhtml/09_Khitan_War_Machine",
 			"component" : XHTML09_KHITAN_WAR_MACHINE
 		},
 		{
 			"path" : "/xhtml/10_Part1",
 			"name" : "xhtml/10_Part1",
 			"component" : XHTML10_PART1
 		},
 		{
 			"path" : "/xhtml/11_Chapter_01",
 			"name" : "xhtml/11_Chapter_01",
 			"component" : XHTML11_CHAPTER_01
 		},
 		{
 			"path" : "/xhtml/12_Chapter_02",
 			"name" : "xhtml/12_Chapter_02",
 			"component" : XHTML12_CHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js